import { gql } from '@apollo/client'

export const Query = gql`
  query Warehouse($companyId: ID!, $filters: WarehouseFilters) {
    warehouses(companyId: $companyId, filters: $filters, first: 1) {
      nodes {
        id
        name
        address
      }
      pageInfo { startCursor endCursor hasNextPage hasPreviousPage }
    }
  }
`
